    var swiper = new Swiper(".new-blog-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
       breakpoints: {
          990: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          0: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          }
        }
    });